import * as React from 'react';

function DetachButton(props) {
    return (
        <svg
            width={46}
            height={45}
            viewBox="0 0 46 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={23.166} cy={22.5} r={22.5} fill="#fff" />
            <path
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                d="M15.193 15.987l-5.825-1.371M17.943 12.922l-2.1-5.604"
            />
            <path
                d="M22.33 34.597l4.383-4.384a7.032 7.032 0 001.85-6.568 6.923 6.923 0 00-4.494-4.978l-.284.284a3.034 3.034 0 00-.797 2.868 3.662 3.662 0 011.365 6.035l-4.383 4.383a3.662 3.662 0 01-5.178-5.177l3.825-3.825a7.674 7.674 0 01-.016-4.208 6.96 6.96 0 00-1.785 1.29L12.433 24.7a6.998 6.998 0 109.896 9.897z"
                fill="url(#prefix__paint0_linear)"
            />
            <path
                d="M32.904 19.304l-3.824 3.824a7.674 7.674 0 01.016 4.208 6.962 6.962 0 001.785-1.29l4.383-4.383a6.998 6.998 0 00-9.897-9.896l-4.383 4.383a6.944 6.944 0 00-1.617 2.55 7.032 7.032 0 00-.232 4.018 6.924 6.924 0 004.493 4.978l.284-.284a3.034 3.034 0 00.798-2.868 3.663 3.663 0 01-1.367-6.035l4.384-4.383a3.661 3.661 0 115.177 5.178z"
                fill="url(#prefix__paint1_linear)"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={13.095}
                    y1={34.399}
                    x2={27.035}
                    y2={22.689}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0091FB" />
                    <stop offset={1} stopColor="#34D2E4" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint1_linear"
                    x1={22.947}
                    y1={25.477}
                    x2={36.33}
                    y2={14.139}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8A00" />
                    <stop offset={1} stopColor="red" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default DetachButton;
